<template>
  <div class="d-flex flex-column">
    <div class="d-flex flex-column fixed-top">
      <div
        class="top-bar d-flex justify-content-between align-items-center pb-2"
      >
        <div class="top-bar-left">
          <ul class="menu">
            <li>
              <div class="mx-4">
                <img :src="img_logo" alt="Beereaders" class="logo-beereaders" />
              </div>
            </li>
            <li @click="resetReadingExperience">
              <router-link
                tooltip="Volver al Inicio"
                class="btn br-color-primary ml-3 "
                :to="'/dashboard/books'"
              >
                <i class="fas fa-2x fa-chevron-left text-logo"></i>
              </router-link>
            </li>
            <li>
              <h4
                class="font-weight-bolder ml-5 w-80 text-truncate text-white mt-1 max"
              >
                {{ readingExperience.bookData.title }}
              </h4>
            </li>
          </ul>
        </div>
        <div class="top-bar-right ml-auto d-flex justify-content-center">
          <ul class="menu">
            <li>
              <br-button
                cssClass="btn  br-color-primary mx-1 "
                :tooltip="'Índice'"
                :imgUrl="img_menu"
                :id="'btn-menu'"
                :name="'btn-menu'"
                v-on:clicked="indexShow"
              ></br-button>
            </li>
            <li>
              <br-button
                cssClass="btn  br-color-primary mx-1 "
                :tooltip="'Preguntas'"
                :imgUrl="img_trazado"
                :id="'btn-trazado'"
                :name="'btn-trazado'"
                v-on:clicked="questionShow"
              ></br-button>
            </li>
            <li>
              <br-button
                cssClass="btn  br-color-primary mx-1 "
                :tooltip="'Diccionario'"
                :imgUrl="img_dict"
                :id="'btn-dictionary'"
                :name="'btn-dictionary'"
                v-on:clicked="dictShow"
              ></br-button>
            </li>
            <!-- <br-book-reader :show="$store.state.reader" v-if="loaded"></br-book-reader> -->
            <!-- <br-book-settings :show="$store.state.settings"></br-book-settings> -->
          </ul>
        </div>
      </div>
      <div>
        <br-indicator></br-indicator>
      </div>
    </div>
    <!-- <br-book-index-content :show="readingExperience.index"></br-book-index-content> -->
    <BrIndexContent :show="readingExperience.index"></BrIndexContent>

    <br-dictionary-content
      :show="readingExperience.dict"
    ></br-dictionary-content>
    <BrQuestionsContent :show="readingExperience.question"></BrQuestionsContent>
  </div>
</template>

<script>
import BrButton from "./common/BrButton";
import BrIndicator from "./common/BrIndicator";
import BrIndexContent from "./utilities/BrIndexContent";
import BrDictionaryContent from "./utilities/BrDictionaryContent";
import BrQuestionsContent from "./utilities/BrQuestionsContent";

import { mapState, mapMutations } from "vuex";
export default {
  name: "br-topbar",
  components: {
    BrButton,
    BrIndicator,
    BrIndexContent,
    BrDictionaryContent,
    BrQuestionsContent,
  },
  computed: {
    ...mapState(["readingExperience"]),
  },
  data() {
    return {
      img_logo: require("@/assets/images/logo-white.svg"),
      img_dict: require("@/assets/images/book/dictionary.png"),
      img_trazado: require("@/assets/images/book/trazado.png"),
      img_menu: require("@/assets/images/book/menu.png"),
    };
  },
  methods: {
    ...mapMutations([
      "showIndex",
      "showDict",
      "showQuestion",
      "resetReadingExperience",
    ]),
    indexShow() {
      this.showIndex();
    },
    dictShow() {
      this.showDict();
    },
    questionShow() {
      this.showQuestion();
    },
  },
};
</script>

<style lang="css" scoped>
.top-bar {
  -webkit-box-shadow: 0px -10px 50px 0px rgba(0, 0, 0, 0.3);
  -moz-box-shadow: 0px -10px 50px 0px rgba(0, 0, 0, 0.3);
  box-shadow: 0px -10px 50px 0px rgba(0, 0, 0, 0.3);
  background: #4e4c56;
  padding-top: 1vh !important;
  padding-bottom: 1vh !important;
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.top-bar,
.top-bar ul {
  background: #4e4c56;
}

.top-bar {
  max-height: 10%;
}

.top-bar .top-bar-left .menu {
  background: #4e4c56;
  margin-left: 25vh;
}

.top-bar .top-bar-right .menu {
  background: #4e4c56;
  margin-right: 25vh;
}

.logo-beereaders {
  height: 7vh;
  width: 20vh;
}

.menu .btn {
  margin: 6px !important;
}

.max {
  max-width: 75vh !important;
}
.br-color-primary {
  color: #ffb511;
}

@media only screen and (max-width: 1024px) {
  .top-bar,
  .top-bar ul {
    background: #4e4c56;
  }

  .top-bar {
    max-height: 10%;
  }

  .top-bar .top-bar-left .menu {
    background: #4e4c56;
    margin-left: 0vh !important;
  }

  .top-bar .top-bar-right .menu {
    background: #4e4c56;
    margin-right: 5vh;
  }

  .logo-beereaders {
    height: 10vh;
    width: 20vh;
  }

  .menu .btn {
    margin: 6px !important;
  }

  .max {
    max-width: 50vh !important;
  }

  .settings-content {
    font-size: 2rem;
    position: absolute;
    background: white;
    color: rgb(177, 184, 199);
    width: 40%;
    z-index: 1000;
    border-radius: 1rem;
    top: 120%;
    right: 5%;
    padding: 1.2rem;
  }

  .auto-reader-content {
    position: absolute;
    background: white;
    width: 35%;
    z-index: 1000;
    border-radius: 1rem;
    padding: 1rem;
    top: 120%;
    text-align: center;
  }

  .sidebar {
    background: #ffffff;
    float: right;
    height: 100%;
    position: fixed;
    right: 0px;
    z-index: 100;
    top: 8%;
    width: 40% !important;
  }

  .sidebar-panel {
    height: 59vh !important;
    overflow: auto;
  }
}
</style>
